// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3uCre","info":"UpdateTermsInfo_info__1Zqen"};